module.exports = __webpack_public_path__ + "static/img/door.6dcace0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/door.png
// module id = VpgY
// module chunks = 1